import { useSearchParams } from 'react-router-dom'
import { useIsMobile } from '../../hooks/useIsMobile'
import { ChatPage } from './ChatPage'
import { MobileConversationsList } from './MobileConversationsList'

/**
 * Router element for `/chat` (no :conversationId). Splits behaviour by
 * viewport width:
 *
 * - Desktop (md+): always ChatPage. The fixed sidebar is already shown
 *   by AppShell, so the user can navigate conversations from there and
 *   the empty ChatPage renders the "em que posso ajudar?" state.
 *
 * - Mobile (<md): the default route shows the conversations list
 *   full-screen (WhatsApp pattern). The `?new=true` query param forces
 *   the empty ChatPage so the list's "Novo" button has somewhere to
 *   send the user without needing a new /chat/new route.
 *
 * `/chat/:conversationId` is handled by a separate route and always
 * renders ChatPage in both breakpoints.
 */
export function ChatIndex() {
  const isMobile = useIsMobile()
  const [searchParams] = useSearchParams()
  const isNew = searchParams.get('new') === 'true'

  if (isMobile && !isNew) {
    return <MobileConversationsList />
  }
  return <ChatPage />
}
